import { Controller } from "@hotwired/stimulus"

// Pins an element to the viewport top after it reaches a scroll threshold.
export default class extends Controller {
  static values = {
    offset: { type: Number, default: 0 }
  }

  connect() {
    this.stuck = false
    this.startY = 0

    this.placeholder = document.createElement("div")
    this.placeholder.setAttribute("aria-hidden", "true")
    this.placeholder.style.display = "none"
    this.element.parentNode.insertBefore(this.placeholder, this.element)

    this.onScroll = this.handleScroll.bind(this)
    this.onResize = this.handleResize.bind(this)

    window.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onResize)

    this.measureStart()
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onResize)

    if (this.stuck) this.unstick()
    this.placeholder.remove()
  }

  handleResize() {
    if (this.stuck) {
      this.placeholder.style.height = `${this.element.offsetHeight}px`
    }

    this.measureStart()
    this.handleScroll()
  }

  handleScroll() {
    const shouldStick = window.scrollY + this.offsetValue >= this.startY

    if (shouldStick && !this.stuck) {
      this.stick()
    } else if (!shouldStick && this.stuck) {
      this.unstick()
    }
  }

  measureStart() {
    if (this.stuck) {
      this.startY = this.placeholder.getBoundingClientRect().top + window.scrollY
      return
    }

    this.startY = this.element.getBoundingClientRect().top + window.scrollY
  }

  stick() {
    this.stuck = true

    this.placeholder.style.display = "block"
    this.placeholder.style.height = `${this.element.offsetHeight}px`

    this.element.style.position = "fixed"
    this.element.style.left = "0"
    this.element.style.right = "0"
    this.element.style.top = `${this.offsetValue}px`
  }

  unstick() {
    this.stuck = false

    this.placeholder.style.display = "none"
    this.placeholder.style.height = "0px"

    this.element.style.position = ""
    this.element.style.left = ""
    this.element.style.right = ""
    this.element.style.top = ""
  }
}
